import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';

const AlertHandler = () => {
  const [alert, setAlert] = useState(null);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handle403 = (event) => {
      const message = event.detail && event.detail.message
        ? event.detail.message
        : 'Access denied. Please upgrade your account.';
      setAlert(message);
      setShow(true);
    };

    window.addEventListener('forbidden403', handle403);

    return () => {
      window.removeEventListener('forbidden403', handle403);
    };
  }, []);

  const handleClose = () => setShow(false);

  const handleUpgrade = () => {
    setShow(false);
    navigate('/console/services');
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header >
        <Modal.Title><h5>Thank you for trying AccessEVA! </h5></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>if you've found out analytics valuable and want to continue benefiting from AccessEVA's cutting-edge analytic services, please consider subscribing now, Stay ahead with the insights you need to make informed decisions.</p>
        <br />
        <p>Subscribe today to unlock the full potential of AccessEVA's services!</p>

      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleUpgrade}>
          Subscribe Now
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>

      </Modal.Footer>
    </Modal>
  );
};

export default AlertHandler;